export const environment = {
  production: true,
  baseApiUrl: 'https://bandoso-api.dttt.vn',
  baseApiUrlLocal: 'https://localhost:5001'
};
